import { CommonModule } from '@angular/common';
import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  EventEmitter,
  Output,
  HostBinding,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { MenuNode, MenuNodeTypes } from 'projects/semeris/src/store/menu/menu.state';

import { FastTooltipDirective } from '../../../shared/directives/fast-tooltip.directive';
import { NgIfVersionDirective } from '../../../shared/directives/ng-if-version.directive';
import { PermissionsDirective } from '../../../shared/directives/permissions.directive';
import { StopPropagationDirective } from '../../../shared/directives/stop-propagation.directive';
import { NgChanges } from '../../../shared/models/common/ng-changes';
import { nextTeaserTooltip } from '../../../shared/services/deployment/deployment-variant';
import { IconButtonDirective } from '../../../ui/button/icon-button/icon-button.directive';

@Component({
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    FastTooltipDirective,
    PermissionsDirective,
    NgIfVersionDirective,
    StopPropagationDirective,
    IconButtonDirective,
  ],
  selector: 'semeris-sidenav-item',
  templateUrl: './sidenav-item.component.html',
  styleUrls: ['./sidenav-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavItemComponent implements OnChanges {
  @Input() menuNode: MenuNode;
  @Input() mode: 'small' | 'large' | string;
  @Input() operationIcon: string;
  @Input() operationName: string;
  @Input() nextTeaserInert = false;

  @HostBinding('class.additional-operation') @Input() showOperation = false;

  @Output() operationClick = new EventEmitter<void>();
  @Output() menuClick = new EventEmitter<MenuNode>();

  public readonly MenuNodeTypes = MenuNodeTypes;
  private readonly clickableNodes = new Set([
    MenuNodeTypes.Button,
    MenuNodeTypes.Collapse,
    MenuNodeTypes.Navigation,
    MenuNodeTypes.JsonEditorField,
  ]);

  public active: boolean;
  public isNextTeaser: boolean;
  public tooltip: string;

  public ngOnChanges(changes: NgChanges<SidenavItemComponent>): void {
    // PERF - removed change test, costs much more than recalculation
    if (changes.menuNode) {
      this.active =
        this.menuNode && (this.menuNode.active || this.menuNode.children?.some((c) => c.active));
      this.isNextTeaser = !!this.menuNode?.nextOnlyPath;
      this.tooltip = this.isNextTeaser ? nextTeaserTooltip(this.menuNode.name) : this.menuNode?.name;
    }
  }

  public clickHandler() {
    if (this.isNextTeaser && this.nextTeaserInert) {
      return;
    }

    if (this.clickableNodes.has(this.menuNode.type)) {
      this.menuClick.emit(this.menuNode);
    }
  }

  public onOperationClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.operationClick.emit();
  }
}
